import { render } from "./LeftSidebarLayout.vue?vue&type=template&id=5d52949d"
import script from "./LeftSidebarLayout.vue?vue&type=script&lang=js"
export * from "./LeftSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/candidate-package/LeftSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d52949d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d52949d', __exports__)) {
    api.reload('5d52949d', __exports__)
  }
  
  module.hot.accept("./LeftSidebarLayout.vue?vue&type=template&id=5d52949d", () => {
    api.rerender('5d52949d', render)
  })

}


export default __exports__